<template>
  <div v-loading.fullscreen="loading">
    <div v-if="!loading">
      <el-breadcrumb style="float: right" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }"> {{$t('route.home')}}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'userList' }">Users</el-breadcrumb-item>
        <el-breadcrumb-item v-if="model">{{ model.email }}</el-breadcrumb-item>
      </el-breadcrumb>

      <h2 class="page-title">{{$t('table.edit')}} User</h2>

      <el-form
        ref="form"
        :model="model"
        :label-position="labelPosition"
        :label-width="labelWidth"
        @submit.native.prevent="save"
      >
        <div class="block">
          <el-form-item label="Email" prop="email">
            <el-col :lg="11" :md="16" :sm="24">
              <el-input v-model="model.email" :disabled="true"/>
            </el-col>
          </el-form-item>

          <el-form-item label="Roles" prop="roles">
            <el-col :lg="11" :md="16" :sm="24">
              <el-select multiple v-model="model.roles" filterable>
                <template v-if="roles">
                  <el-option
                    v-for="option in roles"
                    :key="option.id"
                    :label="option.label"
                    :value="option.id"
                  />
                </template>
              </el-select>
            </el-col>
          </el-form-item>
        </div>

        <div class="button-group mt-3">
          <el-button
            @click="save()"
            :disabled="loading"
            type="primary"
            icon="el-icon-fa-floppy-o"
          >Save</el-button>
          <el-button @click="back()" :disabled="loading" icon="el-icon-fa-times">Cancel</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Roles from "@/auth/roles";

export default {
  name: "app-user-edit",

  props: {
    id: String,
    previous: String
  },

  created() {
    this.$store
      .dispatch("user/edit", this.id)
      .catch(() => this.$router.push({ name: "userList" }));
  },

  beforeRouteLeave(to, from, next) {
    this.$store.dispatch("user/clear");
    next();
  },

  computed: {
    ...mapGetters({
      model: "user/model",
      loading: "user/loading",
      labelPosition: "shared/labelPosition",
      labelWidth: "shared/labelWidth"
    }),

    editing: state => !!state.id,

    roles() {
      return Roles.asArray;
    }
  },

  methods: {
    save() {
      this.$refs.form.validate().then(valid => {
        if (!valid) {
          return;
        }

        this.$store.dispatch("user/update").then(() => {
          this.back();
        });
      });
    },

    back() {
      if (this.previous === "show") {
        this.$router.push({
          name: "userShow",
          params: { id: this.id }
        });
        return;
      }

      this.$router.push({ name: "userList" });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/user/user-edit.vue?46cf6e7e